export default {
  bind: function (el) {
    const input = el.tagName === "INPUT" ? el : el.querySelector("input");
    if (!input) return;

    const trimSpaces = (e) => {
      e.target.value = e.target.value.replace(/\t/g, "").trim();
      e.target.dispatchEvent(new Event("input"));
    };

    input.addEventListener("blur", function (e) {
      trimSpaces(e);
    });

    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.keyCode === 13) {
        trimSpaces(e);
      }
    });
  },
};
